import * as React from "react";
import type { SVGProps } from "react";
const SvgPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.383 3.287a1.2 1.2 0 0 0-1.987.47l-.884 2.65-2.396 2.396-4.488.3c-1.029.068-1.498 1.316-.769 2.045l3.578 3.578-3.182 3.181a1 1 0 0 0 1.414 1.415l3.182-3.182 3.577 3.578c.73.729 1.977.26 2.046-.77l.3-4.488 2.395-2.396 2.651-.883a1.2 1.2 0 0 0 .47-1.987l-5.907-5.907Zm-1.123 4.2.624-1.87 4.076 4.076-1.871.623-3.261 3.261-.232 3.48L6.52 10.98l3.48-.232 3.26-3.261Z"
    />
  </svg>
);
export default SvgPinIcon;
